module.exports = __webpack_public_path__ + "static/Pfalz1-scaled-2461d3c1d87fd5f0d67ba51fb25c6719.jpeg";